import './AdditionalFieldsContainer.scss';
import React from 'react';
import { Field } from 'redux-form';
import { Col, Row } from 'react-bootstrap';
import SelectMenu from '../../../../../../../../../common/components/SelectMenu/SelectMenu';
import FormRow from '../../../../../../../../../common/components/FormRow/FormRow';

const AdditionalFieldsContainer = ({ productId }) => (
  <div className={'additional-fields-container'}>
    <Row>
      <Col sm={12}>
        <FormRow
          labelSize={2}
          fieldSize={6}
          label={<div className={'additional-fields-container--label'}>Voucher Code</div>}
        >
          <Field
            name={'data.attributes.metadata.campaign'}
            component={SelectMenu}
            optionValuePath={'id'}
            source={'campaigns'}
            noCache
            isClearable
            filter={`?filter[product]=${productId}`}
          />
        </FormRow>
      </Col>
    </Row>
  </div>
);

export default AdditionalFieldsContainer;
